'use strict';

module Patersons {

    export class AccountSelectComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/common/components/accountSelect.component.html';
        controller: any = AccountSelectController;
        bindings: any = {
            accounts: '=',
            selectedAccount: '<',
            isDisabled: '<',
            rememberSelection: '<',
            showSelectAccount: '<',
            labelText: '@',
            onAccountChange: '&'
        };
    }

    export class AccountSelectController {
        selectionService: SelectionService;
        private _accounts: Array<Account>;
        private _selectedAccount: Account;
        private useSelectionService: boolean;
        rememberSelection: boolean;
        onAccountChange: any;

        static $inject = ['selectionService'];

        constructor(selectionService) {
            this.selectionService = selectionService;

            if (this.rememberSelection===undefined) {
                this.useSelectionService = true;
            }
            else {
                this.useSelectionService = this.rememberSelection;
            }           
        }

        get accounts(): Array<Account> {
            return this._accounts;
        }

        set accounts(value: Array<Account>){
            this._accounts = value;

            if (!this.useSelectionService) {
                return;
            }

            if (this.selectionService && this.selectionService.selectedAccountId) {
                var account = this.selectionService.getSelectedAccount(this._accounts);

                if (account != null) {                    
                    this._selectedAccount = account;
                    this.onAccountChange({ accountId: this._selectedAccount.accountId });
                }
            }
        }

        get selectedAccount(): Account {
            return this._selectedAccount;
        }

        set selectedAccount(value: Account) {
            this._selectedAccount = value;

            if (!this.useSelectionService) {
                return;
            }

            if (this.selectionService) {
                if (value) {
                    this.selectionService.selectedAccountId = value.accountId;
                }
            }
        }

        // public $onChanges(changesObj) {
        //     console.log("Accounts Select Changed Obj: ");
        //     console.log(changesObj);
        // }
    }
}